import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../images/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/jobs", label: "Jobs" },
    { to: "/prepare", label: "Prepare" },
    { to: "/resume", label: "Resume" },
    { to: "/aboutus", label: "About Us" },
  ];

  const renderLinks = () =>
    links.map(({ to, label }) => (
      <NavLink
        key={to}
        to={to}
        onClick={() => setIsOpen(false)}
        className={({ isActive }) =>
          isActive
            ? "block text-center bg-blue-600 text-white rounded-2xl px-4 py-1 font-semibold tracking-wide transition no-underline"
            : "block text-center text-gray-800 hover:text-blue-600 hover:bg-blue-100 rounded-2xl px-4 py-1 font-semibold tracking-wide transition no-underline"
        }
      >
        {label}
      </NavLink>
    ));

  // Scroll event listener to change navbar background
  useEffect(() => {
    const handleScroll = () => {
      console.log(window.scrollY); // Log the scroll position for debugging
      if (window.scrollY > 60) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`${
        scrolled ? "bg-white shadow-md" : "bg-transparent no-shadow"
      } text-gray-800 sticky top-0 z-[99999] transition-all duration-300 ease-in-out`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <NavLink
              to="/"
              aria-label="Home"
              className={"flex items-center  no-underline"}
            >
              <img src={logo} alt="Thought Code" className="h-16 w-auto" />
              <p className="text-2xl font-bold text-blue-600e m-auto">
                Thought Code
              </p>
            </NavLink>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex flex-grow justify-center space-x-8 items-center">
            {renderLinks()}
          </div>

          {/* Mobile Hamburger */}
          <div className="flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-blue-100 focus:outline-none transition"
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8h16M4 16h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu with Tailwind transition */}
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out md:hidden bg-white shadow-lg ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="flex flex-col items-center px-4 pt-4 pb-6 space-y-3">
          {renderLinks()}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
